import { BrandConfig } from './brands';

export const getThemeConfig = (primaryColor: string) => {
  const darkenColor = (color: string, percent: number): string => {
    const num = parseInt(color.replace("#", ""), 16);
    const amt = Math.round(2.55 * percent);
    const R = (num >> 16) - amt;
    const G = (num >> 8 & 0x00FF) - amt;
    const B = (num & 0x0000FF) - amt;
    return "#" + (
      0x1000000 +
      (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
      (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
      (B < 255 ? (B < 1 ? 0 : B) : 255)
    ).toString(16).slice(1);
  };

  const lightenColor = (color: string, percent: number): string => {
    const num = parseInt(color.replace("#", ""), 16);
    const amt = Math.round(2.55 * percent);
    const R = (num >> 16) + amt;
    const G = (num >> 8 & 0x00FF) + amt;
    const B = (num & 0x0000FF) + amt;
    return "#" + (
      0x1000000 +
      (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
      (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
      (B < 255 ? (B < 1 ? 0 : B) : 255)
    ).toString(16).slice(1);
  };

  const hexToRgba = (hex: string, alpha: number): string => {
    const num = parseInt(hex.replace("#", ""), 16);
    const r = (num >> 16) & 255;
    const g = (num >> 8) & 255;
    const b = num & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  return {
    primary: primaryColor,
    primaryDark: darkenColor(primaryColor, 20),
    primaryLight: lightenColor(primaryColor, 15),
    
    primaryText: darkenColor(primaryColor, 35),
    primaryTextLight: darkenColor(primaryColor, 25),
    
    primaryBorder: darkenColor(primaryColor, 20),
    primaryHover: darkenColor(primaryColor, 20),
    
    primaryBg: hexToRgba(primaryColor, 0.1),
    primaryBgHover: hexToRgba(primaryColor, 0.2),
  } as const;
};

export const THEME_CONFIG = getThemeConfig('#556ee6');

export const getThemeForBrand = (brand: BrandConfig) => {
  return getThemeConfig(brand.primaryColor);
};

